import { Button, Checkbox, FormControlLabel, FormGroup } from "@mui/material";
import AutoCompleteDropdown from "components/autocomplete/AutoCompleteDropdown";
import { generateOptionsFromData } from "helpers";
import { useGetUsersByRoleIdQuery } from "modules/pvs_activities/redux/service/user";
import { USER_TYPE } from "modules/pvs_activities/constants";
import React, { useContext, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { MdCheck } from "react-icons/md";
import DeleteIcon from "@material-ui/icons/Delete";
import { Edit } from "@material-ui/icons";
import { MissionContext } from "../contexts/MissionTasksContext";

const MissionActorsRenderRow = ({ config, actor, index, correspondenceLoading, handleUpdate, handleAddClick, handleDeleteClick, handleSave, canChangeMissionActors }) => {
    const { is_archived } = useContext(MissionContext);
    const { t } = useTranslation();
    const [showForm, setShowForm] = useState(false);
    const [visible, setVisible] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const userRes = useGetUsersByRoleIdQuery({ "user_type": USER_TYPE.azure_ad_user });
    const handleVisible = () => {
        const timer = setTimeout(() => {
            setVisible(true);
        }, 2000);
        return () => clearTimeout(timer);
    }

    const usersOptions = useMemo(() => {
        if (userRes.isSuccess) return generateOptionsFromData(userRes.data, {
            value: "id",
            label: "name",
        });
        return [];
    }, [userRes]);

    return (
        <tr key={actor.mission_actor_type}>
            <td>{index + 1}</td>
            <td>{actor.mission_actor_name}</td>
            {
                config.isActors && (
                    <td>
                        {
                            showForm ? (
                                <AutoCompleteDropdown
                                    className="border-1 rounded-2 border-secondary me-1 flex-grow-1 opacity-50"
                                    showClearIcon={false}
                                    error={false}
                                    required={false}
                                    multiple={false}
                                    hasselectall={false}
                                    name="user_id"
                                    label={t("-1", "Select User")}
                                    options={usersOptions}
                                    onChange={(event, value) => {
                                        handleUpdate(actor, value, "user");
                                    }}
                                    value={usersOptions.find((r) => r.value === actor?.user_id) ?? null}
                                />
                            ) : (
                                <span
                                    className={visible ? 'opacity-60' : 'opacity-50'}
                                >
                                    {actor?.user_id && actor.user_name} - {
                                        actor?.relationUser?.email &&
                                        <i>({actor?.relationUser?.email})</i>
                                    }
                                </span>
                            )
                        }
                    </td>
                )
            }
            {
                config.isMissionCCs && (
                    <td>
                        {
                            showForm ? (
                                <FormGroup>
                                    <FormControlLabel control={
                                        <Checkbox
                                            checked={actor.is_letter_cc}
                                            onChange={(event) => { handleUpdate(actor, event.target.checked, "letter_cc"); }}
                                            color="primary"
                                        />
                                    } label={t("-1", "is Letter CC?")} />
                                </FormGroup>
                            ) : (
                                actor.is_letter_cc ? "Yes" : "No"
                            )
                        }
                    </td>
                )
            }
            {
                canChangeMissionActors() && (
                    <td>
                        <div className="d-flex">
                            {
                                showForm ? (
                                    <Button variant="contained" className="me-1" color="primary" startIcon={<MdCheck />} disabled={correspondenceLoading} onClick={() => { handleAddClick(actor); setShowForm(false); handleVisible(); }}>
                                        Save Changes
                                    </Button>
                                ) : (
                                    <Button
                                        variant="contained"
                                        className="me-1"
                                        color="info"
                                        startIcon={<Edit />}
                                        disabled={is_archived ? true : correspondenceLoading}
                                        onClick={() => {
                                            setShowForm(true);
                                        }}
                                    >
                                        {t("-1", "Edit")}
                                    </Button>
                                )
                            }
                            <Button
                                variant="contained"
                                color="error"
                                startIcon={<DeleteIcon />}
                                disabled={is_archived ? true : deleting}
                                className={deleting ? 'opacity-50 pointer-events-none' : ''}
                                onClick={async () => {
                                    try {
                                        setDeleting(true);
                                        await handleDeleteClick(actor);
                                        setShowForm(false);
                                        setDeleting(false);
                                    } catch (err) {
                                        console.error("Delete failed", err);
                                    }
                                }}
                            >
                                {deleting ? t("-1", "Removing...") : t("-1", "Remove")}
                            </Button>
                        </div>
                    </td>
                )
            }
        </tr>
    )
}

MissionActorsRenderRow.defaultProps = {
    config: {
        isActors: false,
        isMissionCCs: false,
    },
    actor: {},
    index: 0,
    correspondenceLoading: false,
    handleUpdate: () => { },
    handleAddClick: () => { },
    handleDeleteClick: () => { },
    canChangeMissionActors: () => false,
};
export default MissionActorsRenderRow;